import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";
import { Globe, Check } from "@phosphor-icons/react";

const LANGS = ["es", "en", "fr", "de"];

export const LanguageSwitcher = ({ dark = false }) => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = (i18n.language || "es").slice(0, 2);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen(!open)}
        aria-label="Cambiar idioma / Change language"
        className={`flex items-center gap-2 px-3 py-2 border transition-colors duration-300 ${
          dark
            ? "border-sand/30 text-sand hover:bg-sand/10"
            : "border-ink/20 text-ink hover:bg-ink/5"
        }`}
      >
        <Globe size={18} weight="light" />
        <span className="text-xs font-medium tracking-[0.2em] uppercase">{current}</span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="language-menu"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 8 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 w-44 bg-white border border-line shadow-xl z-50"
          >
            {LANGS.map((lng) => (
              <button
                key={lng}
                data-testid={`lang-option-${lng}`}
                onClick={() => {
                  i18n.changeLanguage(lng);
                  setOpen(false);
                }}
                className={`w-full flex items-center justify-between px-4 py-3 text-sm tracking-wide transition-colors hover:bg-sand ${
                  current === lng ? "text-terracotta" : "text-ink"
                }`}
              >
                <span className="flex items-center gap-3">
                  <span className="text-[10px] uppercase tracking-[0.2em] text-ink/40 w-6">{lng}</span>
                  {t(`lang.${lng}`)}
                </span>
                {current === lng && <Check size={14} weight="bold" />}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
